import { render, staticRenderFns } from "./political-choose.vue?vue&type=template&id=14c4904f&scoped=true&"
import script from "./political-choose.vue?vue&type=script&lang=js&"
export * from "./political-choose.vue?vue&type=script&lang=js&"
import style0 from "./political-choose.vue?vue&type=style&index=0&id=14c4904f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4904f",
  null
  
)

export default component.exports